<template>
  <div class="page">
    <section class="info-wrap">
      <el-form label-position="left" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="130px">
        <el-form-item class="style" label="法人开户承诺函（选填）" prop="legalPersonCommitment">
          <div class="img-wrap">
            <div class="img-list">
              <el-upload
                :class="ruleForm.legalPersonCommitment && ruleForm.legalPersonCommitment.length > 0 ? 'hide' : ''"
                list-type="picture-card"
                :file-list="legalPersonCommitmentList"
                :action="$configUrl.uploadUrl"
                :on-remove="handleRemove"
                :on-success="
                  (response, file, fileList) => {
                    return legalPersonCommitmentSuccess(file, fileList);
                  }
                "
              >
                <i class="el-icon-plus"></i>
              </el-upload>
            </div>
            <span class="labels-tips"
              >请上传法定代表人或负责人亲笔签署的开户承诺函扫描件。亲笔签名承诺函内容清晰可变，不得有涂污，破损，字迹不清晰现象。</span
            >
          </div>
        </el-form-item>

        <el-form-item class="style" label="法人开户意愿视频（选填）" prop="legalPersonVideo">
          <div class="img-wrap">
            <div class="img-list">
              <el-upload
                :class="ruleForm.legalPersonVideo && ruleForm.legalPersonVideo.length > 0 ? 'hide' : ''"
                list-type="picture-card"
                :file-list="legalPersonVideoList"
                :action="$configUrl.uploadUrl"
                :on-remove="handleRemove1"
                :on-success="
                  (response, file, fileList) => {
                    return legalPersonVideoSuccess(file, fileList);
                  }
                "
              >
                <i class="el-icon-plus"></i>
              </el-upload>
            </div>
            <p class="labels-tips">相据实际审核情况，会额外要求商家提供。建议法人按以下话术录制“法人开户意愿视频”</p>
            <p class="labels-tips">
              “我是#商户名称#的法定代表人(或负责人)，特此证明本公司申请的商户号为我司真实意高开立且用于XX业务(或XX服务)，我司现有业务符合法律法规及腾讯的相关规定。"录制要求:
            </p>
            <p class="labels-tips">1.请用普通话录制以上视频；</p>
            <p class="labels-tips">2.本视频须采集到清晰正面人检，请务必保持正脸朝向摄像头且不要遮挡面部；</p>
            <p class="labels-tips">3.请避免对录制原始图像和音频进行任何处理(如滤镜、美颜、变音及其他后期效果);</p>
            <p class="labels-tips">4.支持上传5M以内的视频文件，格式可为可为avi、wmv。mpeg、</p>
          </div>
        </el-form-item>

        <el-form-item class="style" label="补充材料（选填）" prop="businessAdditionPics">
          <div class="img-wrap">
            <div class="img-list">
              <el-upload
                :class="ruleForm.businessAdditionPics && ruleForm.businessAdditionPics.length > 0 ? 'hide' : ''"
                list-type="picture-card"
                :file-list="businessAdditionPicsList"
                :action="$configUrl.uploadUrl"
                :on-remove="handleRemove2"
                :on-success="
                  (response, file, fileList) => {
                    return businessAdditionPicsSuccess(file, fileList);
                  }
                "
              >
                <i class="el-icon-plus"></i>
              </el-upload>
            </div>
            <p class="labels-tips">1、在支付完成页向买家展示，需与微信经营类目相关。</p>
            <p class="labels-tips">2、简称要求：</p>
            <p class="labels-tips">
              ① 业务模式不清晰时，需详细描述支付场景或提供相关材料（如业务说明/门店照/手持证件照等）
            </p>
            <p class="labels-tips">② 特殊业务要求提供相关的协议材料等</p>
          </div>
        </el-form-item>
        <el-form-item label="补充说明（选填）" prop="businessAdditionMsg">
          <div class="style">
            <el-input v-model="ruleForm.businessAdditionMsg" placeholder="" clearable></el-input>
          </div>
          <p class="labels-tips">根据驳回要求提供额外信息，如：业务模式不清晰时，请详细描述支付场景。</p>
        </el-form-item>
      </el-form>
    </section>
  </div>
</template>

<script>
export default {
  props: {
    count: {
      type: Number || Boolean,
      default: false,
    },
    allData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      legalPersonCommitmentList: [],
      legalPersonVideoList: [],
      businessAdditionPicsList: [],
      ruleForm: {
        legalPersonCommitment: '',
        legalPersonVideo: '',
        businessAdditionPics: '',
        businessAdditionMsg: '',
      },
      rules: {},
    };
  },
  computed: {},
  watch: {
    count: {
      handler: function () {
        this.validity();
      },
    },
    allData: {
      handler: function (data) {
        console.log(data);
        if (data.supplementaryMaterialsVO) {
          this.ruleForm = data.supplementaryMaterialsVO;
          let legalPersonCommitmentList = data.supplementaryMaterialsVO.legalPersonCommitment.split(',');
          let legalPersonVideoList = data.supplementaryMaterialsVO.legalPersonVideo.split(',');
          let businessAdditionPicsList = data.supplementaryMaterialsVO.businessAdditionPics.split(',');
          this.legalPersonCommitmentList = legalPersonCommitmentList.map((item) => {
            const fileItem = {
              name: 'file',
              url: item,
              response: {
                data: item,
              },
            };
            return fileItem;
          });
          this.legalPersonVideoList = legalPersonVideoList.map((item) => {
            const fileItem = {
              name: 'file',
              url: item,
              response: {
                data: item,
              },
            };
            return fileItem;
          });
          this.businessAdditionPicsList = businessAdditionPicsList.map((item) => {
            const fileItem = {
              name: 'file',
              url: item,
              response: {
                data: item,
              },
            };
            return fileItem;
          });
        }
      },
    },
  },

  methods: {
    legalPersonCommitmentSuccess(file, fileList) {
      console.log(file, fileList);
      this.ruleForm.legalPersonCommitment = file.response.data.url;
      console.log(this.ruleForm.legalPersonCommitment);
      this.$emit('handleMediaId', this.ruleForm.legalPersonCommitment,file.name);
    },
    legalPersonVideoSuccess(file, fileList) {
      console.log(file, fileList);
      this.ruleForm.legalPersonVideo = file.response.data.url;
      console.log(this.ruleForm.legalPersonVideo);
    },
    businessAdditionPicsSuccess(file, fileList) {
      console.log(file, fileList);
      this.ruleForm.businessAdditionPics = file.response.data.url;
      console.log(this.ruleForm.businessAdditionPics);
      this.$emit('additionPicsMediaId', this.ruleForm.businessAdditionPics,file.name);
    },
    handleRemove() {
      this.ruleForm.legalPersonCommitment = [];
    },
    handleRemove1() {
      this.ruleForm.legalPersonVideo = [];
    },
    handleRemove2() {
      this.ruleForm.businessAdditionPics = [];
    },
    validity() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$emit('confirm', { flag: true, ruleForm: this.ruleForm });
          console.log('验证通过');
        } else {
          this.$emit('confirm', { flag: false, ruleForm: this.ruleForm });
          console.log('验证失败');
          return false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import '~@/assets/style/mixins.less';
@import '~@/assets/style/var.less';
.info-wrap {
  box-sizing: border-box;
  padding-left: 31px;
}

.labels-tips {
  font-size: 12px;
  font-weight: 500;
  line-height: 23px;
  color: #999999;
}

/deep/.el-input {
  width: 346px;
}
.img-wrap {
  width: 700px;
  .img-list {
    height: 58px;
    overflow: hidden;
  }
  /deep/ .el-upload--picture-card {
    width: 58px;
    height: 58px;
    line-height: 58px;
  }
  /deep/ .el-upload-list {
    /deep/.el-upload-list__item.is-success:first-child {
      &::before {
        position: absolute;
        left: 0;
        top: 0;
        content: '主图';
        color: #fff;
        width: 100%;
        height: 22px;
        font-size: 12px;
        text-align: center;
        line-height: 22px;
        background: rgba(0, 0, 0, 0.36);
      }
    }
  }
  /deep/ .el-upload-list--picture-card .el-upload-list__item {
    width: 58px;
    height: 58px;
    box-sizing: border-box;
  }
  /deep/ .el-upload--picture-card i {
    font-size: 14px;
  }
  /deep/ .el-upload-list__item-actions {
    width: 58px;
    height: 58px;
  }
  .hide {
    /deep/ .el-upload.el-upload--picture-card {
      display: none;
    }
  }
}
</style>
